import { TIMESTAMP_COLUMN_FORMAT } from 'constants/common'
import { TIMESTAMP_TOOLTIP_DATETIME_FORMAT } from 'constants/dayjs'
import dayjs from 'lib/dayjs'

export const getTimestampColumnFormatValue = (
  timestamp: number,
  format: (typeof TIMESTAMP_COLUMN_FORMAT)[keyof typeof TIMESTAMP_COLUMN_FORMAT]
) =>
  format === TIMESTAMP_COLUMN_FORMAT.AGE
    ? dayjs.unix(timestamp).utc().fromNow()
    : dayjs.unix(timestamp).utc().format(TIMESTAMP_TOOLTIP_DATETIME_FORMAT)

export const getTimestampColumnTooltipFormatValue = (
  timestamp: number,
  format: (typeof TIMESTAMP_COLUMN_FORMAT)[keyof typeof TIMESTAMP_COLUMN_FORMAT]
) =>
  format === TIMESTAMP_COLUMN_FORMAT.AGE
    ? dayjs.unix(timestamp).utc().format(TIMESTAMP_TOOLTIP_DATETIME_FORMAT)
    : dayjs.unix(timestamp).utc().fromNow()

export const getTimestampColumnTooltipText = (
  format: (typeof TIMESTAMP_COLUMN_FORMAT)[keyof typeof TIMESTAMP_COLUMN_FORMAT]
) =>
  format === TIMESTAMP_COLUMN_FORMAT.AGE
    ? `Click to show Datetime format`
    : `Click to show Age format`
